import { SustainabilityShortInfoComponent } from './sustainability-short-info.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ SustainabilityShortComponent: SustainabilityShortInfoComponent });
